// Angular
import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';

// Auth
import {AssetUriService, ConfigService, Globals} from '@aiwyn/config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    public configService: ConfigService,
    private assetUriService: AssetUriService,
    private readonly titleService: Title,
    private globals: Globals,
  ) {
    this.assetUriService.setCustomerAssetUrlFromDomain(window.location.search, this.globals.anTenant);
  }

  ngOnInit(): void {
    this.configService.checkIfMobile();
    this.titleService.setTitle(this.configService.customerName + ' Client Portal');
  }
}
